import React from 'react';
import { CheckCircle, Heart, Shield, Users, MessageCircle } from 'lucide-react';
export function Benefits() {
  return <section className="py-[50px] px-[15px] relative bg-[#F8F6FF]" data-id="element-42">
      <div className="container max-w-[1000px] mx-auto px-[15px] relative z-[2]" data-id="element-43">
        <div className="text-center mb-[40px]" data-id="element-44">
          <h2 className="text-[24px] sm:text-[28px] font-[800] text-[#1A1035] mb-[15px] font-['Montserrat']" data-id="element-45">
            El Apoyo Incondicional existe para esto:
          </h2>
          <p className="text-[#6B7280] max-w-[600px] mx-auto" data-id="element-46">
            Para que dejes de sentirte inútil y empieces a ser el pilar que tu
            familia necesita desesperadamente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]" data-id="element-47">
          <div className="bg-white p-[25px] rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-t-[4px] border-[#7C3AED] hover:shadow-[0_10px_30px_rgba(124,58,237,0.1)] transition-shadow" data-id="element-48">
            <div className="w-12 h-12 bg-[#F3E8FF] rounded-full flex items-center justify-center mb-[15px] mx-auto" data-id="element-49">
              <MessageCircle className="text-[24px] text-[#7C3AED]" data-id="element-50" />
            </div>
            <h3 className="text-[18px] font-bold text-[#1A1035] mb-[10px] text-center" data-id="element-51">
              Palabras que Sanan
            </h3>
            <p className="text-[#4B5563] text-center text-[14px]" data-id="element-52">
              Descubre las <strong data-id="element-53">5 frases exactas</strong> que tu familiar
              necesita escuchar para no sentirse solo, y las 3 que lo hieren
              aunque vengan del amor.
            </p>
          </div>

          <div className="bg-white p-[25px] rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-t-[4px] border-[#7C3AED] hover:shadow-[0_10px_30px_rgba(124,58,237,0.1)] transition-shadow" data-id="element-54">
            <div className="w-12 h-12 bg-[#F3E8FF] rounded-full flex items-center justify-center mb-[15px] mx-auto" data-id="element-55">
              <Users className="text-[24px] text-[#7C3AED]" data-id="element-56" />
            </div>
            <h3 className="text-[18px] font-bold text-[#1A1035] mb-[10px] text-center" data-id="element-57">
              Equipo Familiar
            </h3>
            <p className="text-[#4B5563] text-center text-[14px]" data-id="element-58">
              Organiza los roles para que <strong data-id="element-59">nadie se agote</strong>. El
              cáncer es una guerra familiar, y necesitas un ejército organizado
              de amor.
            </p>
          </div>

          <div className="bg-white p-[25px] rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-t-[4px] border-[#7C3AED] hover:shadow-[0_10px_30px_rgba(124,58,237,0.1)] transition-shadow" data-id="element-60">
            <div className="w-12 h-12 bg-[#F3E8FF] rounded-full flex items-center justify-center mb-[15px] mx-auto" data-id="element-61">
              <Heart className="text-[24px] text-[#7C3AED]" data-id="element-62" />
            </div>
            <h3 className="text-[18px] font-bold text-[#1A1035] mb-[10px] text-center" data-id="element-63">
              Presencia Real
            </h3>
            <p className="text-[#4B5563] text-center text-[14px]" data-id="element-64">
              Aprende a estar presente en el alma, no solo en el cuerpo. Haz que
              tu familiar <strong data-id="element-65">SIENTA</strong> que no está solo en sus peores
              momentos.
            </p>
          </div>

          <div className="bg-white p-[25px] rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-t-[4px] border-[#7C3AED] hover:shadow-[0_10px_30px_rgba(124,58,237,0.1)] transition-shadow" data-id="element-66">
            <div className="w-12 h-12 bg-[#F3E8FF] rounded-full flex items-center justify-center mb-[15px] mx-auto" data-id="element-67">
              <Shield className="text-[24px] text-[#7C3AED]" data-id="element-68" />
            </div>
            <h3 className="text-[18px] font-bold text-[#1A1035] mb-[10px] text-center" data-id="element-69">
              Tu Propio Blindaje
            </h3>
            <p className="text-[#4B5563] text-center text-[14px]" data-id="element-70">
              Protege tu salud mental para poder proteger la de él/ella.{' '}
              <strong data-id="element-71">No puedes dar lo que no tienes.</strong> Evita quebrarte
              en el proceso.
            </p>
          </div>
        </div>
      </div>
    </section>;
}